import { createGlobalStyle } from 'styled-components';
import { palette, font } from 'styled-theme';
// import 'antd/dist/antd.css';

const GlobalStyles = createGlobalStyle`
  /* ===== Largura PADRÃO (base) das janelas/modais de edição =====
     Usada pelo FormWindow (modal padrão) e pelo modal do formulário de
     atividade — os dois têm exatamente a mesma largura. */
  :root {
    --caalga-modal-w: min(1520px, 90vw);
  }

  @media only screen and (max-width: 1280px) {
    :root {
      --caalga-modal-w: 92vw;
    }
  }

  @media only screen and (max-width: 767px) {
    :root {
      --caalga-modal-w: 96vw;
    }
  }

  .ant-btn{
    border-radius: 4px;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    font-size: 12px;
  }

  .tablePayments,
  .tablePayments th,
  .tablePayments td {
    font-size: 12px;
  }

  .center-text {
    text-align: center !important;
  }

  .bankAccountItem p {
    font-size: 12px;
  }
  .bankAccountItem b {
    font-size: 14px;
  }

  .fullWidth{width: 100%;}
  .noPadding{padding: 0 !important;}
    .isDemoIcon{position: absolute; left: 5px; color:red; font-size:18px; font-weight: bold;}

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  .noBorder{border: 0 !important;}
  .inputNormal{
    box-sizing: border-box !important;
    margin: 0 !important;
    font-variant: tabular-nums !important;
    list-style: none !important;
    font-feature-settings: 'tnum' !important;
    position: relative !important;
    display: inline-block !important;
    width: 100% !important;
    min-width: 0 !important;
    padding: 4px 11px !important;
    color: rgba(0, 0, 0, 0.85) !important;
    font-size: 12px !important;
    line-height: 1.5715 !important;
    background-color: #fff !important;
    background-image: none !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 2px !important;
    transition: all 0.3s !important;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: #000000;
        font-family: 'Roboto';
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;

      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid #f4f6fd;

            &:hover,
            &:focus {
              background-color: #ffffff;
            }
          }

          &:hover,
          &:focus {
            background-color: #F3F5FD;
          }

          &:last-child {
            background-color: #E6EAF8;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        margin: 5px 0;
        span {
          font-size: 12px;
          color: #788195;
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;
            h2 {
              margin: 0;
            }
            form {
              padding: 15px 0 3px;
              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }


/*-----------------------------------------------*/
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
}

font-family: ${font('primary', 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette('primary', 0)};
    color: #fff;
  }
}

.ant-row:not(.ant-form-item) {
  ${'' /* margin-left: -8px;
  margin-right: -8px; */};
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/********** Add Your Global CSS Here **********/

body {
  -webkit-overflow-scrolling: touch;
}

html h1,
html h2,
html h3,
html h4,
html h5,
html h6,
html a,
html p,
html li,
input,
textarea,
span,
div,
html,
body,
html a {
  margin-bottom: 0;
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
}

html ul {
  -webkit-padding-start: 0px;
  list-style: none;
  margin-bottom: 0;
}

.scrollbar-track-y,
.scrollbar-thumb-y {
  width: 5px !important;
}

.scrollbar-track-x,
.scrollbar-thumb-x {
  height: 5px !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
}

.scrollbar-track {
  background: rgba(222, 222, 222, 0.15) !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-bottomRight
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-topLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-topRight
  > .ant-popover-content
  > .ant-popover-arrow:after {
  left: 0;
  margin-left: -4px;
}

/* Instagram Modal */

.ant-modal-wrap.instagram-modal .ant-modal {
  max-width: 935px;
  width: 100% !important;
}

@media only screen and (max-width: 991px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    padding: 0 60px;
  }
}

@media only screen and (max-width: 767px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    max-width: 580px;
  }
}

.ant-modal-wrap.instagram-modal .ant-modal-content {
  border-radius: 0;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close {
  position: fixed;
  color: #fff;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close i {
  font-size: 24px;
}

.ant-modal-wrap.instagram-modal .ant-modal-content .ant-modal-body {
  padding: 0;
}

/********** Add Your Global RTL CSS Here **********/

/* Popover */

html[dir='rtl'] .ant-popover {
  text-align: right;
}

/* Ecommerce Card */

html[dir='rtl'] .isoCardInfoForm .ant-input {
  text-align: right;
}

/* Modal */

html[dir='rtl'] .has-success.has-feedback:after,
html[dir='rtl'] .has-warning.has-feedback:after,
html[dir='rtl'] .has-error.has-feedback:after,
html[dir='rtl'] .is-validating.has-feedback:after {
  left: 0;
  right: auto;
}

html[dir='rtl'] .ant-modal-close {
  right: inherit;
  left: 0;
}

html[dir='rtl'] .ant-modal-footer {
  text-align: left;
}

html[dir='rtl'] .ant-modal-footer button + button {
  margin-left: 0;
  margin-right: 8px;
}

html[dir='rtl'] .ant-confirm-body .ant-confirm-content {
  margin-right: 42px;
}

html[dir='rtl'] .ant-btn > .anticon + span,
html[dir='rtl'] .ant-btn > span + .anticon {
  margin-right: 0.5em;
}

html[dir='rtl'] .ant-btn-loading span {
  margin-left: 0;
  margin-right: 0.5em;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
  padding-left: 25px;
  padding-right: 29px;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
  .anticon {
  margin-right: -14px;
  margin-left: 0;
}

/* Confirm */

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-body > .anticon {
  margin-left: 16px;
  margin-right: 0;
  float: right;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns {
  float: left;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns button + button {
  margin-right: 10px;
  margin-left: 0;
}

/* Message */

html[dir='rtl'] .ant-message .anticon {
  margin-left: 8px;
  margin-right: 0;
}

/* Pop Confirm */

html[dir='rtl'] .ant-popover-message-title {
  padding-right: 20px;
  padding-left: 0;
}

html[dir='rtl'] .ant-popover-buttons {
  text-align: left;
}

/* Notification */

html[dir='rtl']
  .ant-notification-notice-closable
  .ant-notification-notice-message {
  padding-left: 24px;
  padding-right: 0;
}

html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-message,
html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  margin-right: 48px;
}

html[dir='rtl'] .ant-notification-notice-close {
  right: auto;
  left: 16px;
}

html[dir='rtl'] .ant-notification-notice-with-icon {
  left: 0;
}

/* Dropzone */

html[dir='rtl'] .dz-hidden-input {
  display: none;
}

.redLineRow td{color:red !important;}
.throughLineRow{text-decoration: line-through !important;}

  /* Campos digitados seguem a escrita do usuário (sem forçar caixa alta). */

  /* Dados exibidos nas TABELAS (listas e formulários) em MAIÚSCULO.
     Cabeçalhos (th) ficam normais, pois são rótulos. */
  /* Células das tabelas seguem a escrita original dos dados. */

  /* Dentro das células, botões/links (Ações) mantêm a escrita normal */
  .ant-table-tbody > tr > td .ant-btn,
  .ant-table-tbody > tr > td .ant-btn span,
  .ant-table-tbody > tr > td a,
  .ant-table-tbody > tr > td .ant-tag,
  .ant-table-tbody > tr > td svg {
    text-transform: none;
  }

  /* Nunca aplicar em áreas que não são dados (chat, editor de e-mail, kanban).
     Usa !important porque o seletor global de input tem especificidade alta. */
  .chatWrapper input,
  .chatWrapper textarea,
  .emailCompose input,
  .emailCompose textarea,
  .emailBody input,
  .emailBody textarea,
  .copilot-input,
  .ant-upload input,
  .scrumBoard input,
  .scrumBoard textarea {
    text-transform: none !important;
  }

  /* LOGIN: usuário e senha com escrita normal (maiúsculas e minúsculas) */
  .loginPageWrappper input,
  .loginPageWrappper textarea,
  .loginPageWrappper .ant-input,
  .loginPageWrappper .ant-input-affix-wrapper > input.ant-input {
    text-transform: none !important;
  }

  /* E-MAIL e CHAT DE IA: o que o usuário digita aparece como digitou */
  .caalgaNoUpper input,
  .caalgaNoUpper textarea,
  .caalgaNoUpper select,
  .caalgaNoUpper .ant-input,
  .caalgaNoUpper .ant-select-selection-item,
  .caalgaNoUpper .ant-select-selection-placeholder,
  .caalgaNoUpper .ant-select-selection-search-input,
  .caalgaNoUpper .ant-table-cell,
  .caalgaNoUpper td,
  .copilot-panel input,
  .copilot-panel textarea,
  .copilot-panel .ant-input,
  .copilot-panel .ant-select-selection-item,
  .copilot-panel .ant-table-cell,
  .copilot-panel td {
    text-transform: none !important;
  }

  /* ============ LISTA COMPACTA DENTRO DE FORMULÁRIOS ============
     Mesmo desenho do bloco de itens (vendas/OS): linhas baixas,
     números à direita, ações por ícone e rodapé de totais. */
  .compactListBlock {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
  }

  .compactListTable .ant-table {
    font-size: 12px;
  }

  .compactListTable .ant-table-thead > tr > th {
    padding: 6px 8px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    color: #8a94a6;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .compactListTable .ant-table-tbody > tr > td {
    padding: 4px 8px;
    border-bottom: 1px solid #f6f8fa;
  }

  .compactListTable .ant-select-selector,
  .compactListTable .ant-input,
  .compactListTable .ant-input-number {
    height: 28px !important;
    min-height: 28px !important;
    font-size: 12px !important;
  }

  .compactListTable .ant-select-selection-item,
  .compactListTable .ant-select-selection-placeholder {
    line-height: 26px !important;
  }

  .compactListTable .ant-input-number-input {
    height: 26px !important;
  }

  .compactListFooter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    padding: 6px 10px;
    border-top: 1px solid #f0f0f0;
    background: #fcfdff;
    font-size: 12px;
    color: #475569;
  }

  /* ================= PADRÃO DOS FORMULÁRIOS =================
     Mesmo tamanho/fonte dos campos do modal de edição (cadastro de produtos).
     Aplicado pela classe .caalga-form no conteúdo do formulário. */
  .caalga-form .isoFieldLabel {
    margin-bottom: 5px;
    font-size: 13px;
    line-height: 1.35;
    color: #475569;
  }

  .caalga-form .isoFieldset {
    margin-bottom: 10px;
  }

  .caalga-form .ant-input,
  .caalga-form .ant-input-affix-wrapper,
  .caalga-form .ant-input-number,
  .caalga-form .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 34px;
    font-size: 12px !important;
    line-height: 22px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .caalga-form .ant-input-affix-wrapper > input.ant-input {
    height: auto;
    line-height: 22px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .caalga-form .ant-select-multiple .ant-select-selector {
    height: auto !important;
    min-height: 34px;
    padding: 3px 8px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .caalga-form .ant-select-multiple .ant-select-selection-item {
    margin-top: 2px;
    margin-bottom: 2px;
    line-height: 20px;
    font-size: 12px;
  }

  .caalga-form .ant-select-single .ant-select-selector .ant-select-selection-item,
  .caalga-form .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 32px;
    font-size: 12px !important;
  }

  .caalga-form .ant-input-number-input {
    height: 32px;
    font-size: 12px !important;
  }

  .caalga-form textarea.ant-input {
    height: auto;
    font-size: 12px;
  }

  .caalga-form .ant-table,
  .caalga-form .ant-table table,
  .caalga-form .ant-table-thead > tr > th,
  .caalga-form .ant-table-tbody > tr > td {
    font-size: 12px;
  }

  .caalga-form input,
  .caalga-form textarea,
  .caalga-form select,
  .caalga-form .ant-input-number-input,
  .caalga-form .ant-select-selection-item,
  .caalga-form .ant-select-selection-placeholder,
  .caalga-form .ant-select-selection-search-input,
  .caalga-form .ant-table-cell {
    font-size: 12px !important;
  }

  .caalga-form .ant-card-head,
  .caalga-form .ant-card-head-title {
    font-size: 15px;
    font-weight: 600;
    color: #334155;
  }

  /* Editores de texto (TinyMCE/draft) ficam com a escrita NORMAL e 13px:
     maiúsculo é só para os campos de dados. */
  .caalga-form .mce-content-body,
  .caalga-form [contenteditable='true'],
  .caalga-form .DraftEditor-root,
  .caalga-form .public-DraftEditor-content,
  .caalga-form .ql-editor {
    text-transform: none;
    font-size: 13px !important;
  }

  /* ================= PADRÃO DOS MINI MODAIS (antd) =================
     Mesma linguagem das janelas da mesa: topo no cinza das abas, cantos de
     6px, título 15px e rodapé discreto. Vale para TODOS os modais antd. */
  /* Mesmo raio das janelas de edição (FormWindow) */
  .ant-modal-content {
    border-radius: var(--caalga-radius-janela, 6px);
    overflow: hidden;
  }

  /* Cabeçalho com a MESMA altura/formato do header do modal de edição */
  .ant-modal-header {
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 18px;
    background: #eef2f7;
    border-bottom: 1px solid #dde4ec;
    border-radius: var(--caalga-radius-janela, 6px) var(--caalga-radius-janela, 6px) 0 0;
  }

  /* Título no formato do modal de edição: | TÍTULO ————— (X) */
  .ant-modal-title {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.2;
    color: #1e293b;
    overflow: hidden;
    white-space: nowrap;
    padding-right: 40px;
  }

  /* marcador vertical (mesmo do FormWindow) */
  .ant-modal-title::before {
    content: '';
    flex: 0 0 auto;
    width: 3px;
    height: 22px;
    border-radius: 2px;
    background: #3b82f6;
  }

  /* linha que vai do título até o "x" */
  .ant-modal-title::after {
    content: '';
    flex: 1 1 auto;
    height: 1px;
    min-width: 20px;
    background: #d5dde6;
  }

  .ant-modal-close {
    top: 11px;
    right: 12px;
    width: 34px;
    height: 34px;
    border-radius: 8px;
    color: #64748b;
    font-size: 16px;
    transition: background-color 0.15s ease, color 0.15s ease;
  }

  .ant-modal-close:hover,
  .ant-modal-close:focus {
    background: rgba(15, 23, 42, 0.07);
    color: #0f172a;
  }

  .ant-modal-body {
    padding: 16px 18px;
    /* Modal alto (ex.: formulário da atividade) rola POR DENTRO: cabeçalho e
       rodapé continuam visíveis e todo o conteúdo fica acessível. */
    max-height: calc(100vh - 240px);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
  }

  .ant-modal-body::-webkit-scrollbar {
    width: 10px;
  }

  .ant-modal-body::-webkit-scrollbar-track {
    background: transparent;
  }

  .ant-modal-body::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    border-radius: 10px;
    background-color: #cbd5e1;
    background-clip: content-box;
  }

  .ant-modal-body::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
  }

  .ant-modal-footer {
    padding: 10px 18px;
    border-top: 1px solid #eef2f7;
  }

  /* ================= CAMADAS (z-index) =================
     Janela de cadastro 2400 < modal antd 2650 < dropdown 2750 < avisos 2850.
     Assim nenhum dropdown/lista abre atrás de modal ou da janela de cadastro. */
  .ant-modal-root .ant-modal-wrap,
  .ant-modal-root .ant-modal-mask {
    z-index: 2650 !important;
  }

  .ant-select-dropdown,
  .ant-dropdown,
  .ant-picker-dropdown,
  .ant-popover,
  .ant-tooltip,
  .ant-cascader-dropdown,
  .ant-auto-complete-dropdown,
  /* menu de "3 pontinhos" dos blocos (menu/submenu do antd) */
  .ant-menu-submenu-popup,
  .ant-menu-submenu > .ant-menu,
  .ant-dropdown-menu-submenu-popup {
    z-index: 2750 !important;
  }

  .ant-message,
  .ant-notification {
    z-index: 2850 !important;
  }
`;

export default GlobalStyles;
